<template>
		<router-view></router-view>
</template>
<script>



export  default {
    data:function(){


        return {

        }
    }

}

</script>
<style scoped>
  .el-main {
    color: #333;
    text-align: center;
  }

	/*.slide-fade-enter-active {*/
		/*transition: all .3s ease;*/
	/*}*/
	/*.slide-fade-leave-active {*/
		/*transition: all .3s ease;*/
	/*}*/
	.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active for below version 2.1.8 */ {
		transform: translateX(10px);
		opacity: 0;
	}
</style>




// WEBPACK FOOTER //
// src/layouts/customer/CustomerIndex.vue